import React, { useContext } from 'react'
import { Box, Typography } from '@mui/material'

import { ScreenContext } from 'apps/utils/ScreenContext'
import { usePageTitle } from 'apps/utils/usePageTitle'
import Wrapper from 'apps/common/Wrapper'

import theme from 'theme'
import { useStyles } from './styles'
import { TechSvg } from '../../tech.js'

const TechStack = () => {
	usePageTitle( 'Tech Stack — ACT Software' )
	const classes = useStyles()
	const { isLaptop, isLandscape } = useContext( ScreenContext )

	return (
		<Wrapper footerNavClassName={ classes.footerNav }>
			<Box
				display='grid'
				className={ classes.techWrapper }
			>
				{isLaptop &&
					<Box
						position='relative'
						width='100%'
						borderRight='1px solid var(--line)'
						textTransform='uppercase'
						paddingTop='127px'
						overflow='hidden'
						display='flex'
						justifyContent='center'
						alignItems='flex-start'
					>
						<Typography
							fontSize='10vw'
							fontWeight='bold'
							color='var(--ink)'
							sx={{
								writingMode: 'tb',
								transform: 'scale(-1)',
								textTransform: 'uppercase'
							}}
						>
							Tech Stack
						</Typography>
					</Box>
				}
				<Box
					maxWidth={ isLaptop ? '1155px' : '100%' }
					marginRight={ isLaptop ? '104px' : '0' }
					borderRight='1px solid var(--line)'
				>
					<Box paddingRight={ theme.spacing( 6 ) }>
						<Typography variant='h1' textAlign='right' fontSize={ isLaptop ? '88px' : '60px' }>
							tech stack
						</Typography>
					</Box>
					{ /* Negative margin (not `top`) so the mesh tucks under the h1
					     without leaving a same-size hole below it — a relative `top`
					     shift keeps the box's original footprint, which showed up as
					     ~100px of dead space above the footer. */ }
					<Box
						position='relative'
						marginTop='-103px'
						paddingBottom={ isLandscape ? '0' : '259%' }
					>
						<TechSvg />
					</Box>
				</Box>
			</Box>
			<Box
				position='relative'
				marginRight={ isLaptop ? '104px' : '0' }
				borderRight='1px solid var(--line)'
				className={ classes.footerWrapper }
			>
				<Box
					onClick={ () => window.scrollTo( { top: 0, behavior: 'smooth' } ) }
					role='button'
					borderTop='1px solid var(--line)'
					borderLeft='1px solid var(--line)'
					height='64px'
					display='flex'
					alignItems='center'
					justifyContent='center'
					fontSize={ 18 }
					fontWeight={ 700 }
					color='var(--ink)'
					sx={ {
						cursor: 'var(--cursor-pointer)',
						transition: 'background-color 0.25s ease',
						'&:hover': { backgroundColor: 'var(--hover)' }
					} }
				>
					<Box component='span' fontSize={ 26 } fontWeight={ 400 } marginRight='28px'>⬠</Box>
					Lift me up
					<Box component='span' fontSize={ 26 } fontWeight={ 400 } marginLeft='28px'>⬠</Box>
				</Box>
			</Box>
		</Wrapper>
	)
}

export default TechStack
